import { Person } from "models/person";
import { SimpleTopic } from "models/simpleTopic";
import { TopicRibbon } from 'models/topicRibbon';
import { JSONTopicListItem, TopicListItem } from "../models/topicListItem";

const { languageCode } = settings;

export function shouldShowToDoBadge(topic: SimpleTopic, person: Person) {
    return person.isRegular() && topic.shouldBeAnswered();
}

/**
 * Determines if a private badge should be shown to mods/obs in the live site for those topics which have the comments visibility set to 'HideAll'
 * @param person - target person
 * @param topicContentType - target topic content type
 * @param commentsVisibility - The comments visibility settings
 */
export function isPrivateBadgeVisible(person: Person, topicContentType?: number, commentsVisibility?: number) {
    //let's not show 'Private' badge for 'Information only' topics as they are obvious to be private and we never show comments there 
    if (topicContentType === enums.TopicContentTypes.InformationOnly.value)
        return false; 

    return person.isModeratorOrObserver() ? commentsVisibility == enums.CommentsVisibilityType.HideAll.value : false;
}

export function getIdeationStageName(stage: number) {
    switch (stage) {
        case enums.IdeationStages.IdeaCreation.value: return labels.Creation;
        case enums.IdeationStages.IdeaReview.value: return labels.Review;
        case enums.IdeationStages.IdeaRating.value: return labels.Rating;
        default: return '';
    }
}

export function getTopicRibbon(user: Person, topic: SimpleTopic): TopicRibbon | undefined {
    if (!topic.isGroup()) {
        if (user.isMember()) {
            if (topic.shouldBeAnswered())
                return { title: labels.ToDo, type: `wcc-ribbon--${languageCode} wcc-ribbon--red` };
        } else if (user.isModeratorOrObserver()) {
            if (isPrivateBadgeVisible(user, topic.contentType(), topic.commentsVisibility()))
                return { title: labels.Private, type: `wcc-ribbon--${languageCode} wcc-ribbon--red` };

            if (topic.isIdeation()) {
                const stage = topic.ideationStage();

                switch (stage) {
                    case enums.IdeationStages.IdeaCreation.value: return { title: getIdeationStageName(stage), type: `wcc-ribbon--${languageCode} wcc-ribbon--green` };
                    case enums.IdeationStages.IdeaReview.value: return { title: getIdeationStageName(stage), type: `wcc-ribbon--${languageCode} wcc-ribbon--blue` };
                    case enums.IdeationStages.IdeaRating.value: return { title: getIdeationStageName(stage), type: `wcc-ribbon--${languageCode} wcc-ribbon--orange` };
                }
            }
        }
    }
}



export function BuildTopicListItemsWithGroups(activities: JSONTopicListItem[]) {
    activities = _.filter(activities, function (a) { return a.TopicType != WCC.Enums.TopicType.Screener.value && a.TopicType != WCC.Enums.TopicType.Survey.value; });
    let existingActivities: TopicListItem[] = [];

    var groups = _.filter(activities, function (a) { return a.IsGroup; });
    if (groups.length) {
        _.each(groups, function (g) {
            var group = {
                text: g.Title,
                children: _.chain(activities)
                    .filter(function (a) { return a.GroupId == g.DiscussionTopicId; })
                    .map(function (a) { return { id: a.DiscussionTopicId, text: a.Title } })
                    .value()
            };
            existingActivities.push(group);
        });
    }
    else {
        existingActivities = _.map(activities, function (a) {
            return { id: a.DiscussionTopicId, text: a.Title };
        });
    }

    return existingActivities;
}